const STORAGE_PREFIX = 'playtech-enrolled';

const buildKey = (userId: string, region: string): string => `${STORAGE_PREFIX}:${userId}:${region}`;

export const getCachedPlaytechEnrollment = (userId: string, region: string): boolean => {
    if (!userId || !region || typeof window === 'undefined') {
        return false;
    }

    try {
        return window.localStorage.getItem(buildKey(userId, region)) === '1';
    } catch {
        return false;
    }
};

export const setCachedPlaytechEnrollment = (userId: string, region: string): void => {
    if (!userId || !region || typeof window === 'undefined') {
        return;
    }

    try {
        window.localStorage.setItem(buildKey(userId, region), '1');
    } catch {
        /* noop */
    }
};
